import React, {useEffect, useMemo, useState} from 'react'
import PeriodSearch from 'components/molcules/PeriodSearch'
import {useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import useToolbarStyles from 'components/Table/useTableToolbarStyles'
import {
  dateToPeriodString,
  formatDateFromStringV1,
  formatStringFromDate,
  getDefaultPeriodDate,
} from 'helpers/dateHelper'
import ToolbarSearch from 'pages/ProductHistory/PurchaseHistoryList/ToolbarSearch'
import useProductManagement from 'features/productManagement/useProductManagement'
import {getQueryFromUrl} from 'helpers/commonHelper'

interface TableToolbarProps {
  // handleChangeDate: (dateInput: Date | null) => void
  // date: Date
  // handleChangeKeyword: (e: string) => void
  // keyword: string
}

const TableToolbar = (props: TableToolbarProps) => {
  const location = useLocation()
  const {t} = useTranslation()
  const {handleGetProductPurchaseHistory} = useProductManagement()
  const [selection, setSelection] = useState(getDefaultPeriodDate())

  const classes = useToolbarStyles()

  // const {query, onSearch} = useEdf()
  // const {onOpen: onFailureModalOpen} = useFailureModal()
  const initQuery = getQueryFromUrl(location.search)

  const handleSearch = () => {}
  // onSearch({...query, search, paging: {page: 0, size: 10}})

  const handlePeriod = (period: PeriodDate) => {
    const formatedPeriod = dateToPeriodString(period)
    if (
      formatedPeriod.startDate === initQuery.paymentDateFrom &&
      formatedPeriod.endDate === initQuery.paymentDateTo
    ) {
      return
    }

    handleGetProductPurchaseHistory({
      ...initQuery,
      paymentDateFrom: formatDateFromStringV1(period.startDate),
      paymentDateTo: formatDateFromStringV1(period.endDate),
    })
    setSelection(period)
  }

  useEffect(() => {
    handleGetProductPurchaseHistory({
      paymentDateFrom: formatDateFromStringV1(selection.startDate),
      paymentDateTo: formatDateFromStringV1(selection.endDate),
    })
  }, [])
  return (
    <div>
      <div className={classes.root}>
        <div className={classes.container}>
          <PeriodSearch period={selection} onSearch={handlePeriod} />
          <ToolbarSearch onSearch={handleSearch} />
        </div>
      </div>
    </div>
  )
}

export default TableToolbar
